module.exports = __webpack_public_path__ + "img/nodata-03.b5f872ad.png";